const collapsibleCategoriesBevavior = () => {
  if (!CPB.getStore().getState().Product.metafields?.find(mf => mf.key === 'custom-collapsible-options')?.value) return
  const collapseCategory = (catElem) => {
    if (catElem.classList.contains('cpb-category-collapse-active') && !catElem.classList.contains('always-uncollapse')) {
      catElem.querySelector('.cpb-category-collapse-button').click();
    }
  };
  const uncollapseCategory = (catElem) => {
    if (!catElem.classList.contains('cpb-category-collapse-active')) {
      catElem.querySelector('.cpb-category-collapse-button').click();
    }
  };

  const optionUpdateHandler = () => {
    const allCatElems = document.querySelectorAll('.cpb-category');

    allCatElems.forEach((catElem, i, arr) => {
      if (arr[i + 1] && arr[i + 1].querySelector('.cpb-active')?.textContent.toLowerCase() == 'yes' ) {
        collapseCategory(catElem);
      } else {
        uncollapseCategory(catElem);
      }
    })
    
  };

  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
    setTimeout(optionUpdateHandler);
  })
};

const showFirstStepAlways = () => {
  const panelContainer = document.querySelector('.cpb-panels-container')
  if (panelContainer.classList.contains('col-list')) {
    const panel = document.querySelectorAll('.cpb-panel-wrapper')[0]
    const contentContainer = panel.querySelectorAll('.cpb-category-content')
    const panelNextBtn = panel.querySelectorAll('.cpb-category-next-step-btn')
    contentContainer.forEach(cont => {
      cont.style.visibility = 'visible'
      cont.style.opacity = '1'
      cont.style.setProperty("height", "auto", "important");
    })
    panelNextBtn.forEach(btn => {
      btn.click()
      btn.style.display = 'none'
    })
    const productDesc = document.querySelector('.cpb-product-description')
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function(event) {
      const panels = document.querySelectorAll('.cpb-panel-wrapper:not(:first-child)');
      const selectedPanel = document.querySelector(`[data-panel-id="${event.detail.selectPanelID}"]`);
      const selectedPanelContent = selectedPanel.querySelectorAll('.cpb-category-content')
      panels.forEach(panel => panel.style.display = 'none')
      selectedPanel.style.display = 'block'
      selectedPanelContent.forEach(cont => {
        cont.style.visibility = 'visible'
        cont.style.opacity = '1'
        cont.style.setProperty("height", "auto", "important");
      })
    })
  }
}

const selectOptions = async () => {
  const getFrontendApi = await CPB.FrontendApi();
  const FrontendApi = new getFrontendApi();

  let isUpdating = false;

  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', async function (event) {
    if (isUpdating) return;
    isUpdating = true;

    const store = CPB.getStore();
    const state = store.getState();
    const newLayers = event.detail.newLayers || [];

    if (!newLayers.length) {
      isUpdating = false;
      return;
    }

    let optionsToUpdate = new Set();

    newLayers.forEach(newLayer => {
      const panel = state.Product.panels.find(p => p.id === newLayer.panel);
      if (!panel) return;

      const category = panel.categories.find(c => c.id === newLayer.category);
      if (!category) return;

      const option = category.options.find(o => o.id === newLayer.option && o.metafields?.some(mf => mf.key && mf.value === '0'));
      if (!option) return;

      state.Product.panels.forEach(p => {
        p.categories.forEach(c => {
          c.options.forEach(o => {
            if (o.metafields?.some(mf => option.metafields.some(smf => smf.key === mf.key && mf.value === '1'))) {
              optionsToUpdate.add(JSON.stringify({ panel: p, cat: c, opt: o })); 
            }
          });
        });
      });
    });

    const updates = Array.from(optionsToUpdate).map(item => JSON.parse(item));

    for (const { panel, cat, opt } of updates) {
      await FrontendApi.updateOptions({
        panel,
        category: cat,
        options: [opt],
      });
    }

    isUpdating = false;
  });
};

const showPrevButton = () => {
  const panels = document.querySelectorAll('.cpb-panel-wrapper.eyeshadow')
  let visiblePanel = Array.from(panels).find(el => getComputedStyle(el).display === 'block');
  panels.forEach((panel, index) => {
    const nextButton = panel.querySelector('.cpb-category-next-step-btn')
    if (index !== 0) {
      if (panel.querySelector('.cpb-category-prev-step-btn')) return
      const contentContainer = panel.querySelector('.cpb-category-content')
      const prevButton = document.createElement('div')
      prevButton.textContent = 'Back to previous'
      prevButton.classList.add('cpb-category-prev-step-btn')
      if (contentContainer) {
        contentContainer.appendChild(prevButton)
      }

      prevButton.addEventListener('click', () => {
        const check = Array.from(panels).find(el => getComputedStyle(el).display === 'block')
        panels[Array.from(panels).indexOf(check)].style.display = 'none'
        panels[Array.from(panels).indexOf(check) - 1].style.display = 'block'
      })
    }
  })
}



document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  showFirstStepAlways();
  selectOptions();
  collapsibleCategoriesBevavior();

});






